import React from 'react';
import { Table } from 'semantic-ui-react';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import SubnavigationBar from 'components/SubnavigationBar';
// @ts-ignore
import EventsTimelineDatePagination from 'components/EventsTimelineDatePagination';
// @ts-ignore
import EventsTimelineSettingsDropdown from 'components/EventsTimelineSettingsDropdown';
import AlignLeftAndRight from 'components/AlignLeftAndRight';

// @ts-ignore
import EventsTimelineGroupRows from './components/EventsTimelineGroupRows';
// @ts-ignore
import EventsTimelineHead from './components/EventsTimelineHead';

const EventsTimeline = (): React.ReactElement => (
    <ErrorBoundary
        namespace="EventsTimeline"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <ErrorGate namespace="EVENTS_LOAD">
            <SubnavigationBar>
                <AlignLeftAndRight
                    left={<EventsTimelineDatePagination />}
                    right={<EventsTimelineSettingsDropdown />}
                />
            </SubnavigationBar>
            <Table
                celled
                fixed
                striped
                singleLine
                unstackable
                // HACK inline styles
                style={{
                    borderTop: 'none',
                    borderRight: 'none',
                    borderLeft: 'none',
                    marginTop: 0,
                    marginBottom: 20,
                    borderRadius: 0,
                    overflow: 'hidden'
                }}
            >
                <EventsTimelineHead />
                <Table.Body>
                    <EventsTimelineGroupRows />
                </Table.Body>
            </Table>
        </ErrorGate>
    </ErrorBoundary>
);

export default EventsTimeline;
